<script lang="ts" setup>
	import { ElNotification } from "element-plus";
	import { ref } from "vue";
	import { CrmAttachmentForm } from "~/types/AttachmentForm";
	import { ElementUIFormRef } from "~/types/element-ui/ElementUIFormRef";
	import { FormRuleType } from "~/types/element-ui/FormRuleType";
	import { useCrmAttachmentsStore } from "../stores/attachmentsStore";

	const attachmentsStore = useCrmAttachmentsStore();

	const formRef = ref<ElementUIFormRef | null>(null);
	const emit = defineEmits(["add-attachment", "close-attachment-modal"]);
	const prop = defineProps({
		showHeader: {
			type: Boolean,
			default: true,
		},
		showAttachmentModal: {
			type: Boolean,
			default: true,
		},
		relatedType: {
			type: String,
			required: true,
		},
		relatedId: {
			type: Number,
			default: null,
		},
	});

	const attachmentForm = ref({
		related_type: prop.relatedType,
		related_id: prop.relatedId,
	} as CrmAttachmentForm);

	const rules = reactive<FormRuleType>({
		name: [
			{
				required: true,
				message: "name is required",
				trigger: "blur",
			},
		],
	});

	const multipartFormData = new FormData();
	const fileInputRef = ref();
	const handleFileChange = (event) => {
		const file = event.target.files[0];
		multipartFormData.set("attachment", file);
	};

	const addAttachment = function () {
		if (!formRef.value) {
			ElNotification({
				title: "Failed",
				message: "Please provide all the required fields",
				type: "error",
			});
		}
		formRef.value?.validate(async (valid: any) => {
			if (valid) {
				for (const [key, value] of Object.entries(attachmentForm.value)) {
					if (value !== null) {
						multipartFormData.set(key, value);
					}
				}
				const response = await attachmentsStore.addAttachment(
					multipartFormData
				);
				emit("add-attachment", response?.data);

				formRef.value?.resetFields();
				fileInputRef.value.value = null;
				emit("close-attachment-modal");
			} else {
				console.log("error in validation");
			}
		});
	};

	const closeAttachmentModal = async function () {
		formRef.value?.resetFields();
		fileInputRef.value.value = null;
		emit("close-attachment-modal");
	};
</script>
<template>
	<el-dialog
		v-model="prop.showAttachmentModal"
		:lock-scroll="false"
		:modal="false"
		width="35%"
		align-center
		draggable
		@close="closeAttachmentModal"
	>
		<template #header="{ titleId, titleClass }">
			<div class="my-header flex flex-col gap-1">
				<h4 :id="titleId" class="text-md" :class="titleClass">Add File</h4>
			</div>
		</template>
		<div class="p-2">
			<el-form
				ref="formRef"
				:model="attachmentForm"
				:rules="rules"
				class="space-y-5"
				@submit.prevent="addAttachment"
			>
				<div class="form-elem-container my-2">
					<FormLabel>File</FormLabel>
					<input
						ref="fileInputRef"
						type="file"
						name="file"
						accept=".jpg, .jpeg, .png, .pdf,.ppt, .pptx, .xlx,.xlxs, .doc, .docx"
						@change="handleFileChange"
					/>
				</div>
				<el-form-item prop="name">
					<div class="form-elem-container">
						<FormLabel :required="true">Name</FormLabel>
						<el-input v-model="attachmentForm.name" />
					</div>
				</el-form-item>

				<el-form-item class="" prop="description">
					<div class="form-elem-container">
						<FormLabel> Description</FormLabel>
						<el-input v-model="attachmentForm.description" type="textarea" />
					</div>
				</el-form-item>

				<div class="w-full flex gap-2 items-center justify-end">
					<NavButton type="button" @click="closeAttachmentModal">
						Cancel</NavButton
					>
					<NavButton class="bg-light-purple-nav" type="submit">
						Submit
					</NavButton>
				</div>
			</el-form>
		</div>
	</el-dialog>
</template>
